import { getCommonFilterConfig } from '@bingads-webui-campaign/common-grid-config';
import { extend } from 'underscore';

const getSearchFilterPlaceHolder = (i18n, gridName) => {
  let placeHolder = '';
  switch (gridName) {
    case 'HotelIdGrid':
      placeHolder = i18n.getString('HotelCenter_Overview_Grid_SearchBox_Hotel_Id_Label');
      break;
    case 'HotelGroupGrid':
      placeHolder = i18n.getString('HotelCenter_Overview_Grid_SearchBox_Hotel_Group_Label');
      break;
    default:
      placeHolder = '';
      break;
  }
  return placeHolder;
};

export function getFilterConfig({
  entitySchema,
  i18n,
  sessionStore,
  preferenceStoreFactory,
  legacyGlobalI18n,
  schemaI18nCampaign,
  dataContextManager,
  preferenceService,
  appConfig,
  jsData,
  gridName,
}) {
  const permissions = appConfig.get('Permissions');
  const filterConfig = getCommonFilterConfig(extend({
    preferenceService,
    featureName: `HotelCenterOverviewGrid${gridName}`,
    entitySchema,
    i18n,
    legacyGlobalI18n,
    sessionStore,
    preferenceStoreFactory,
    globalConfig: appConfig,
    schemaI18nCampaign,
    dataContextManager,
    jsdata: jsData,
    editor: {},
    enableCampaignWaterfall: false,
    enableAdGroupWaterfall: false,
    enableAvgPositionDeprecation: permissions.IsAvgPositionDeprecationPhase3Enabled ? permissions.IsAvgPositionDeprecationPhase3Enabled : false,
    searchbox: {
      placeholder: getSearchFilterPlaceHolder(i18n, gridName),
      searchProperty: 'Name',
      searchOperator: '$contains',
    },
  }, gridName === 'HotelIdGrid' ?
    {
      selector: [{
        property: 'Status',
        items: [
          {
            text: i18n.getString('HotelCenter_Overview_Hotel_Quickfilter_AllButDeleted'),
            value: ['Enum.Status\'Active\''],
          },
          {
            text: i18n.getString('HotelCenter_Overview_Hotel_Quickfilter_All'),
            value: null,
          },
        ],
        removable: false,
        defaultValue: null,
      }],
    } : {}));

  return filterConfig;
}
